import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum HousekeepingAssignmentTypeId {
  TEMPORARY = 'temporary',
  PERMANENT = 'permanent',
}

export class HousekeepingAssignmentType extends Codebook<HousekeepingAssignmentTypeId> {
  static readonly TEMPORARY = new HousekeepingAssignmentType(
    HousekeepingAssignmentTypeId.TEMPORARY,
    () => $t('Short term'),
  )

  static readonly PERMANENT = new HousekeepingAssignmentType(
    HousekeepingAssignmentTypeId.PERMANENT,
    () => $t('Long term'),
  )

  private constructor(
    id: HousekeepingAssignmentTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
